/** @param {object | undefined} problem Row from problems.json */
export function getInitialEditorCode(problem) {
  return problem?.starterCode ?? '';
}
